// One owner for the backend Google OAuth entry URL. Login/signup use the plain entry;
// Shopify signup may add only the reviewed, opaque context pair (never credentials/provider code).
export interface ShopifyGoogleContext {
  shop: string
  shopify_context: string
}

export function buildGoogleAuthRedirectUrl(
  apiAppUrl: string,
  context?: ShopifyGoogleContext,
): string {
  const base = apiAppUrl.endsWith('/') ? apiAppUrl : `${apiAppUrl}/`
  const url = new URL('auth/redirect_to_google/', base)
  if (context) {
    url.searchParams.set('shop', context.shop)
    url.searchParams.set('shopify_context', context.shopify_context)
  }
  return url.toString()
}
